import React from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Modal, ModalBody } from 'reactstrap';

import Button from '../../components/Button';
import { translate } from '../../components/Translate';
import { selectProducts } from '../../queries/selectors/products';
import { selectDeviceCountry } from '../../queries/selectors/user';
import { selectSubscriptionList } from '../../queries/selectors/bootstrap';

const Wrapper = ({ WrappedComponent, type, ...props }) => {
  let products = [];
  if (['plan', 'addOn'].includes(type)) {
    products = props.products.filter((product) => product.productType === type);
  }

  if (props.subscriptions && props.subscriptions.length > 0) {
    products = products.filter((product) => props.subscriptions.findIndex(s => s.productId === product.productID) === -1);
  }

  if (!products || products.length === 0) {
    return (
      <>
        <Modal className="crm-modal" centered isOpen backdropClassName="no-available-products-container">
          <ModalBody>
            <div className="PaymentStatus">
              <div className="PaymentStatus__main">
                <p style={{ fontSize: '18px' }}>
                  <FormattedMessage
                    id={`MyAccount.noAvailableProducts.description.${type}`}
                  />
                  <FormattedMessage
                    id={`Country.${props.userCountry}`}
                  />.
                </p>
                <Button text={translate(props.intl, 'MyAccount.menu.goBack')} onClick={props.history.goBack} />
              </div>
            </div>
          </ModalBody>
        </Modal>
        <WrappedComponent {...props} />;
      </>
    )
  }

  return <WrappedComponent {...props} />;
}

Wrapper.propTypes = {
  products: PropTypes.array.isRequired,
  subscriptions: PropTypes.array.isRequired,
  WrappedComponent: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  userCountry: PropTypes.string.isRequired,
  intl: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => ({
  products: selectProducts(state),
  subscriptions: selectSubscriptionList(state),
  userCountry: selectDeviceCountry(state),
})

const WrapperWithProps = compose(
  injectIntl,
  withRouter,
  connect(mapStateToProps),
)(Wrapper);

const withNoAvailableProducts = (type) => (WrappedComponent) => (props) => {
  return <WrapperWithProps {...props} type={type} WrappedComponent={WrappedComponent} />
}

export default withNoAvailableProducts;
